<template>
    <section class="relative isolate overflow-hidden bg-white px-6 lg:px-8" id="testimonials">
        <!-- component -->
        <div class="min-w-screen min-h-screen flex items-center justify-center">
            <div class="w-full bg-white border-t border-gray-200 px-5 py-16 md:py-24 text-gray-800">
                <div class="w-full max-w-6xl mx-auto">
                    <div class="text-center max-w-xl mx-auto">
                        <h2 class="text-base/7 font-semibold text-emerald-600">Testimonials</h2>
                        <p
                            class="mt-2 text-pretty text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl lg:text-balance">
                            What people are saying
                        </p>
                        <!-- <div class="text-center mb-10">
                            <span class="inline-block w-1 h-1 rounded-full bg-indigo-500 ml-1"></span>
                            <span class="inline-block w-3 h-1 rounded-full bg-indigo-500 ml-1"></span>
                            <span class="inline-block w-40 h-1 rounded-full bg-indigo-500"></span>
                            <span class="inline-block w-3 h-1 rounded-full bg-indigo-500 ml-1"></span>
                            <span class="inline-block w-1 h-1 rounded-full bg-indigo-500 ml-1"></span>
                        </div> -->
                    </div>
                    <div class="-mx-3 md:flex items-start mt-8 sm:mt-16 lg:mt-20">
                        <div 
                            v-for="(group, index) in groupedTestimonials"
                            :key="index"
                            class="px-3 md:w-1/3">
                            <div
                                v-for="testimonial in group"
                                :key="testimonial.id"
                                class="w-full mx-auto rounded-lg bg-white border border-gray-200 p-5 text-gray-800 font-light mb-6">
                                <div class="w-full flex mb-4 items-center">
                                    <div
                                        class="overflow-hidden rounded-full w-10 h-10 bg-gray-50 border border-gray-200">
                                        <img src="/images/default-avatar.png" alt="">
                                    </div>
                                    <div class="flex-grow pl-3">
                                        <h6 class="font-bold uppercase text-gray-600">{{ testimonial.name }}</h6>
                                    </div>
                                </div>
                                <div class="w-full">
                                    <p class="leading-tight"><span
                                            class="text-lg leading-none italic font-bold text-gray-400 mr-1">"</span>{{ testimonial.testimonial }}
                                        <span
                                            class="text-lg leading-none italic font-bold text-gray-400 ml-1">"</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';

const testimonials = ref([]);
const groupedTestimonials = ref([]);

onMounted(async () => {
    const response = await axios.get('/api/testimonials');
    testimonials.value = response.data.data;

    for (let i = 0; i < testimonials.value.length; i += 2) {
        groupedTestimonials.value.push(testimonials.value.slice(i, i + 2));
    }
});
</script>